export const activity = {
  title: "Actividad",
  description: "Quién usó qué certificado, dónde y cuándo.",
  tabs: {
    signatures: "Firmas",
    navigation: "Navegación",
    admin: "Administración",
  },
  privacy:
    "Este registro es dato personal de tus empleados: debes informarles. Se conserva {{days}} días.",
  privacyNoRetention:
    "Este registro es dato personal de tus empleados: debes informarles.",
  export: {
    button: "Exportar",
    csv: "Exportar CSV",
    json: "Exportar JSON",
    loginsCsv: "Exportar logins (CSV)",
    loginsJson: "Exportar logins (JSON)",
    done: "Descargado {{name}}",
    hint: "Con los filtros de esta pestaña (máximo un año).",
  },
  filters: {
    user: "Persona",
    allUsers: "Todas las personas",
    credential: "Certificado",
    allCredentials: "Todos los certificados",
    host: "Sede",
    allHosts: "Todas las sedes",
    path: "Dirección contiene…",
    decision: "Resultado",
    allDecisions: "Todos los resultados",
    purpose: "Uso",
    allPurposes: "Todos los usos",
    result: "Resultado",
    allResults: "Todos los resultados",
    category: "Categoría",
    allCategories: "Todas las categorías",
    action: "Acción",
    allActions: "Todas las acciones",
    actor: "Quién",
    allActors: "Todo el mundo",
    period: "Periodo",
  },
  columns: {
    time: "Hora",
    user: "Persona",
    request: "Dirección",
    result: "Resultado",
    credential: "Certificado",
    where: "Dónde",
    purpose: "Uso",
    action: "Acción",
    actor: "Quién",
    target: "Sobre",
  },
  empty: {
    navigation: "No hay navegación con certificados del cloud en este periodo.",
    signatures: "No hay firmas en este periodo.",
    admin: "No hay acciones de administración en este periodo.",
  },
  loadMore: "Cargar más",
  openDetail: "Ver el detalle de {{what}}",
  detail: {
    loginTitle: "Login",
    navigationTitle: "Petición",
    signatureTitle: "Firma",
    adminTitle: "Acción",
    user: "Persona",
    credential: "Certificado",
    rule: "Regla",
    ruleLabel: "{{policy}} · regla {{number}}",
    noRule: "Ninguna (denegado por defecto)",
    device: "Mac",
    app: "App",
    status: "Código HTTP",
    url: "URL",
    method: "Método",
    occurredAt: "Cuándo (según el Mac)",
    receivedAt: "Recibida",
    createdAt: "Cuándo",
    purpose: "Uso",
    host: "Sede",
    format: "Formato",
    operation: "Operación",
    origin: "Origen web",
    algorithm: "Algoritmo",
    fingerprint: "Huella de lo firmado (SHA-256)",
    latency: "Latencia",
    latencyValue: "{{ms}} ms",
    reason: "Motivo",
    result: "Resultado",
    category: "Categoría",
    action: "Acción",
    actor: "Quién",
    target: "Sobre",
    ip: "IP",
    before: "Antes",
    raw: "Antes y después en bruto",
    changes: "Cambios",
    field: "Campo",
    after: "Después",
    details: "Datos",
    nothing: "—",
    notLoaded:
      "Este evento no está en los resultados cargados. Cambia los filtros o carga más.",
  },
  createRule: {
    title: "Crear regla para esta ruta",
    description:
      "Abre el editor de la política con una regla ya rellena con esta ruta (escapada como expresión) y el probador cargado con esta URL.",
    deny: "Denegar esta ruta",
    allow: "Permitir esta ruta",
  },
  seePolicy: "Ver la política",
  categories: {
    admin: "Administración",
    access: "Accesos",
    support: "Soporte",
    system: "Sistema",
  },
  actorTypes: {
    system: "Sistema",
    app: "App de Mac",
    support: "Soporte de Punto",
    platform_admin: "Plataforma",
  },
  reasons: {
    policy_denied: "Lo deniega la política",
    credential_suspended: "Certificado suspendido",
    no_valid_version: "Sin versión válida",
    membership_suspended: "Persona suspendida",
    signature_limit_exceeded: "Límite de firmas superado",
    unsupported_algorithm: "Algoritmo no admitido",
    key_backend_error: "Fallo de KMS",
    login_sin_host: "Login sin host con permiso «*»",
  },
  actions: {
    auth_login: "Entró",
    auth_logout: "Salió",
    policy_created: "Creó una política",
    policy_updated: "Cambió una política",
    policy_deleted: "Borró una política",
    credential_created: "Añadió un certificado",
    credential_updated: "Cambió un certificado",
    credential_suspended: "Suspendió un certificado",
    credential_reactivated: "Reactivó un certificado",
    credential_version_created: "Subió una versión",
    credential_version_activated: "Activó una versión",
    credential_version_scheduled: "Programó una versión",
    credential_version_retired: "Retiró una versión",
    credential_version_rolled_back: "Volvió a una versión anterior",
    user_invited: "Invitó a una persona",
    user_role_changed: "Cambió un rol",
    user_removed: "Quitó a una persona",
    user_suspended: "Suspendió a una persona",
    user_reactivated: "Reactivó a una persona",
    group_created: "Creó un grupo",
    group_updated: "Cambió un grupo",
    group_deleted: "Borró un grupo",
    group_members_added: "Añadió miembros a un grupo",
    group_member_removed: "Quitó a alguien de un grupo",
    organization_updated: "Cambió la organización",
    support_granted: "Concedió acceso de soporte",
    support_revoked: "Revocó el acceso de soporte",
    retention_purged: "Borró lo caducado (retención)",
    audit_exported: "Exportó el registro",
    app_session_revoked: "Cerró una sesión de la app",
  },
  actionGroups: {
    auth: "Entradas y salidas",
    policy: "Políticas",
    credential: "Certificados",
    user: "Personas",
    group: "Grupos",
    organization: "Organización",
    support: "Soporte",
    retention: "Retención",
    audit: "Exportaciones",
  },
  targetTypes: {
    policy: "Política",
    user: "Persona",
    credential: "Certificado",
    credential_version: "Versión de certificado",
    group: "Grupo",
    organization: "Organización",
    support_grant: "Acceso de soporte",
  },
  results: {
    success: "Correcto",
    failure: "Fallo",
    denied: "Denegado",
  },
  you: "Tú",
};
